"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var themes_1 = require("./themes");

exports.getFactor = function (size) {
  if (!size) {
    return 1;
  }

  if (size === 'xs') {
    return 0.5;
  }

  if (size === 'sm') {
    return 0.75;
  }

  if (size === 'lg') {
    return 1.25;
  }

  if (size === 'xl') {
    return 1.5;
  }

  if (size === 'xxl') {
    return 1.75;
  }

  if (size === '2x') {
    return 2;
  }

  if (size === '3x') {
    return 3;
  }

  return 1;
};

function getBorderRadius(propertyName) {
  return function (_a) {
    var borderRadius = _a.borderRadius,
        theme = _a.theme;

    var _b, _c, _d, _e;

    var radius = borderRadius !== undefined ? borderRadius : (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b[propertyName]) === null || _c === void 0 ? void 0 : _c.borderRadius, _d !== null && _d !== void 0 ? _d : (_e = themes_1.defaultTheme[propertyName]) === null || _e === void 0 ? void 0 : _e.borderRadius);
    return typeof radius === 'string' ? radius : radius + "px";
  };
}

exports.getBorderRadius = getBorderRadius;